import { IMAGES } from "@/content";

/**
 * Inhalte der lokalen SEO-Landingpages. Jeder Eintrag = eine Route /<slug>.
 * Haupt-TCGs sind bewusst Pokémon & One Piece; Yu-Gi-Oh! & Zubehör ergänzen.
 */
export const landingData = {
  "pokemon-karten-koeln": {
    crumbLabel: "Pokémon Karten Köln",
    eyebrow: "Pokémon TCG",
    kanji: "ポケモン",
    heroImage: IMAGES.tcgCards,
    heroAlt: "Pokémon Karten im Shibuya Anime & TCG Store Köln",
    h1: "Pokémon Karten kaufen in Köln",
    intro: [
      "Du suchst Pokémon Karten in Köln? Im Shibuya Anime & TCG Store auf der Zülpicher Straße 357 findest du Booster, Displays, Einzelkarten und Zubehör – zum Anfassen, Prüfen und direkt Mitnehmen. Pokémon ist neben One Piece unser stärkster Schwerpunkt.",
      "Statt blind online zu bestellen, kannst du bei uns vor Ort stöbern, dich beraten lassen und deine Karten sofort einpacken. Ob Einsteiger oder Sammler-Profi – wir helfen dir, genau das Richtige für deine Sammlung oder dein Deck zu finden.",
    ],
    metaTitle: "Pokémon Karten kaufen Köln | Booster, Displays & Einzelkarten",
    metaDescription:
      "Kaufe Pokémon Karten, Booster, Displays, Einzelkarten und Zubehör direkt im Shibuya Anime & TCG Store Köln. Deutsch, Englisch & Japanisch – vor Ort auf der Zülpicher Str. 357.",
    keywords:
      "Pokémon Karten kaufen Köln, Pokémon Einzelkarten Köln, Pokémon Booster Köln, Pokémon Display Köln, Pokémon Store Köln, Pokémon TCG Köln",
    sections: [
      {
        heading: "Booster, Displays & Einzelkarten",
        kanji: "商品",
        body: [
          "Bei uns bekommst du das komplette Pokémon-Sortiment für dein Hobby: einzelne Booster Packs zum Aufreißen, ganze Displays (Booster-Boxen) für die große Pull-Session und sorgfältig sortierte Einzelkarten – von gängigen Commons bis zu gefragten Chase-Karten und Sammlerstücken.",
        ],
        bullets: [
          "Booster Packs & Displays aktueller Sets",
          "Einzelkarten – Commons bis Chase & Sammlerkarten",
          "Elite Trainer Boxen, Tins & Special Editions",
          "Zubehör: Sleeves, Toploader, Binder & Deckboxen",
        ],
      },
      {
        heading: "Deutsch, Englisch & Japanisch",
        kanji: "言語",
        body: [
          "Pokémon Karten gibt es bei uns in verschiedenen Sprachen – je nach Verfügbarkeit deutsch, englisch und japanisch. Gerade japanische Karten sind bei Sammlern wegen Druckqualität und exklusiven Sets sehr beliebt. Frag uns einfach, was aktuell da ist.",
        ],
        bullets: [
          "Moderne Sets & beliebte Sammlerkarten",
          "Japanische Karten nach Verfügbarkeit",
          "Persönliche Beratung von Sammlern für Sammler",
        ],
      },
      {
        heading: "Ankauf & Tausch in Köln",
        kanji: "買取",
        body: [
          "Du willst Pokémon Karten nicht nur kaufen, sondern auch verkaufen oder tauschen? Wir kaufen Sammlungen, Sealed-Produkte und Einzelkarten an – mit fairer Bewertung und sofortiger Auszahlung vor Ort. Und bei unseren Trade Days findest du Tauschpartner direkt in der Community.",
        ],
        bullets: [
          "Karten-Ankauf mit Sofort-Auszahlung",
          "Tausch & Trade Days mit der Community",
          "Faire, transparente Bewertung am Marktwert",
        ],
      },
    ],
    faqs: [
      { q: "Habt ihr Pokémon Karten in Köln vor Ort?", a: "Ja, im Shibuya Anime & TCG Store in der Zülpicher Str. 357, 50935 Köln, findest du Booster, Displays, Einzelkarten und Zubehör direkt zum Mitnehmen." },
      { q: "Verkauft ihr einzelne Pokémon Karten?", a: "Ja, wir führen ein Sortiment an Einzelkarten – von gängigen Karten bis zu gefragten Sammler- und Chase-Karten, je nach Verfügbarkeit." },
      { q: "Habt ihr japanische Pokémon Karten?", a: "Je nach Verfügbarkeit führen wir auch japanische Pokémon Karten und Produkte. Frag am besten kurz im Store oder per WhatsApp nach dem aktuellen Bestand." },
      { q: "Kauft ihr Pokémon Karten auch an?", a: "Ja. Wir kaufen Pokémon-Sammlungen, Sealed-Produkte und Einzelkarten an – mehr dazu auf unserer Ankauf-Seite. Auszahlung sofort in bar oder als Store-Gutschein." },
    ],
    related: [
      { to: "/one-piece-karten-koeln", label: "One Piece Karten Köln" },
      { to: "/tcg-zubehoer-koeln", label: "TCG Zubehör Köln" },
      { to: "/ankauf", label: "Karten Ankauf" },
      { to: "/anfahrt", label: "Anfahrt & Öffnungszeiten" },
    ],
  },

  "one-piece-karten-koeln": {
    crumbLabel: "One Piece Karten Köln",
    eyebrow: "One Piece TCG",
    kanji: "海賊",
    heroImage: IMAGES.tcgCards,
    heroAlt: "One Piece TCG Einzelkarten im Shibuya Store Köln",
    h1: "One Piece Karten kaufen in Köln",
    intro: [
      "One Piece Karten in Köln gesucht? Im Shibuya Anime & TCG Store bekommst du Booster, Displays und Einzelkarten des One Piece Card Game – vor Ort auf der Zülpicher Straße 357. Neben Pokémon ist One Piece unser zweiter großer Schwerpunkt.",
      "Ob du gerade ins Spiel einsteigst oder gezielt Leader, Alt Arts und Manga Rares für dein Deck oder deine Sammlung suchst – komm vorbei, prüfe die Karten selbst und nimm sie direkt mit.",
    ],
    metaTitle: "One Piece Karten kaufen Köln | Booster, Displays & Einzelkarten",
    metaDescription:
      "One Piece TCG Karten, Booster, Displays, Alt Arts, Leader Cards und Zubehör im Shibuya Anime & TCG Store Köln kaufen. Vor Ort auf der Zülpicher Str. 357.",
    keywords:
      "One Piece Karten kaufen Köln, One Piece TCG Köln, One Piece Einzelkarten Köln, One Piece Booster Köln, One Piece Display Köln, One Piece Leader Köln",
    sections: [
      {
        heading: "Booster, Displays & Einzelkarten",
        kanji: "商品",
        body: [
          "Für das One Piece Card Game führen wir Booster Packs und Displays der aktuellen Sets sowie ein Sortiment an Einzelkarten. So kannst du gezielt die Karten kaufen, die dir in deinem Deck noch fehlen – ohne auf ganze Boxen angewiesen zu sein.",
        ],
        bullets: [
          "Booster Packs & Displays aktueller Sets",
          "Einzelkarten für Deckbau & Sammlung",
          "Zubehör: Sleeves, Deckboxen & Playmats",
        ],
      },
      {
        heading: "Leader, Alt Arts & Manga Rares",
        kanji: "希少",
        body: [
          "Besonders gefragt sind im One Piece TCG die Leader-Karten, Alternative Arts und Manga Rares. Solche Sammlerkarten führen wir nach Verfügbarkeit – frag uns einfach, was gerade da ist, oder schreib uns kurz per WhatsApp.",
        ],
        bullets: [
          "Leader-Karten für unterschiedliche Decks",
          "Alt Arts & Manga Rares nach Verfügbarkeit",
          "Japanische & englische Karten je nach Bestand",
        ],
      },
      {
        heading: "Community & Events",
        kanji: "仲間",
        body: [
          "One Piece lebt von der Community. Bei unseren Trade Days und Events triffst du andere Spieler und Sammler aus Köln, tauschst Karten und tüftelst gemeinsam an Decks. Schau auf unsere Events-Seite für die nächsten Termine.",
        ],
        bullets: [
          "Trade Days & Community-Treffen in Köln",
          "Karten tauschen & Decks besprechen",
          "Ankauf gefragter One Piece Singles",
        ],
      },
    ],
    faqs: [
      { q: "Habt ihr One Piece Karten in Köln?", a: "Ja, im Shibuya Anime & TCG Store in der Zülpicher Str. 357, 50935 Köln, bekommst du Booster, Displays und Einzelkarten des One Piece Card Game vor Ort." },
      { q: "Verkauft ihr One Piece Einzelkarten?", a: "Ja, wir führen ein Sortiment an One Piece Einzelkarten – darunter gefragte Leader, Alt Arts und Sammlerkarten, je nach Verfügbarkeit." },
      { q: "Kauft ihr One Piece Karten an?", a: "Ja, wir kaufen aktuelle One Piece TCG-Karten und gefragte Singles an. Bewertung und Auszahlung erfolgen direkt vor Ort." },
      { q: "Gibt es One Piece Events in Köln?", a: "Bei unseren Trade Days und Community-Treffen kommen One Piece Spieler und Sammler zusammen. Die nächsten Termine findest du auf unserer Events-Seite." },
    ],
    related: [
      { to: "/pokemon-karten-koeln", label: "Pokémon Karten Köln" },
      { to: "/tcg-events-koeln", label: "TCG Events Köln" },
      { to: "/ankauf", label: "Karten Ankauf" },
      { to: "/anfahrt", label: "Anfahrt & Öffnungszeiten" },
    ],
  },

  "yugioh-karten-koeln": {
    crumbLabel: "Yu-Gi-Oh! Karten Köln",
    eyebrow: "Yu-Gi-Oh! TCG",
    kanji: "遊戯",
    heroImage: IMAGES.tcgCards,
    heroAlt: "Yu-Gi-Oh! Karten im Shibuya Anime & TCG Store Köln",
    h1: "Yu-Gi-Oh! Karten kaufen in Köln",
    intro: [
      "Auch Yu-Gi-Oh!-Fans kommen im Shibuya Anime & TCG Store in Köln auf ihre Kosten. Neben unseren Schwerpunkten Pokémon und One Piece führen wir nach Verfügbarkeit Yu-Gi-Oh! Booster, Displays und Einzelkarten – vor Ort auf der Zülpicher Straße 357.",
      "Ob du Meta-Karten für dein Deck, ältere Karten für die Sammlung oder einfach Zubehör suchst: Komm vorbei, sieh dir die Karten direkt an und lass dich beraten.",
    ],
    metaTitle: "Yu-Gi-Oh! Karten kaufen Köln | Booster, Displays & Einzelkarten",
    metaDescription:
      "Yu-Gi-Oh! Karten, Booster, Displays, Einzelkarten und Zubehör im Shibuya Anime & TCG Store Köln – nach Verfügbarkeit. Vor Ort auf der Zülpicher Str. 357.",
    keywords:
      "Yu-Gi-Oh Karten kaufen Köln, Yu-Gi-Oh Köln, Yugioh Einzelkarten Köln, Yu-Gi-Oh Booster Köln, Sammelkarten kaufen Köln",
    sections: [
      {
        heading: "Booster, Displays & Einzelkarten",
        kanji: "商品",
        body: [
          "Für Yu-Gi-Oh! führen wir je nach Verfügbarkeit Booster, Displays und Einzelkarten. So findest du sowohl Nachschub für dein Deck als auch einzelne Karten, die dir noch fehlen – ganz ohne online bestellen zu müssen.",
        ],
        bullets: [
          "Booster & Displays nach Verfügbarkeit",
          "Einzelkarten für Deck & Sammlung",
          "Zubehör: Sleeves, Toploader & Deckboxen",
        ],
      },
      {
        heading: "Meta-Karten, Sammlerstücke & ältere Karten",
        kanji: "収集",
        body: [
          "Vom aktuellen Meta bis zu nostalgischen älteren Karten: Wir wissen, dass Yu-Gi-Oh! eine riesige Geschichte hat. Frag uns nach gefragten Karten oder bring deine Wunschliste mit – wir sagen dir, was da ist.",
        ],
        bullets: [
          "Gefragte Meta- & Turnier-Karten nach Bestand",
          "Sammlerstücke & ältere Karten",
          "Beratung rund um Decks & Sammlung",
        ],
      },
      {
        heading: "Zubehör & Ankauf",
        kanji: "買取",
        body: [
          "Schütze deine Yu-Gi-Oh! Karten mit passendem Zubehör – Sleeves, Toploader und Deckboxen bekommst du direkt bei uns. Und wenn du Karten abgeben möchtest: Wir kaufen gefragte TCG-Karten an, fair bewertet und sofort ausgezahlt.",
        ],
        bullets: [
          "Zubehör zum Schutz deiner Karten",
          "Ankauf gefragter Karten vor Ort",
          "Sofortige, transparente Auszahlung",
        ],
      },
    ],
    faqs: [
      { q: "Habt ihr Yu-Gi-Oh! Karten in Köln?", a: "Ja, im Shibuya Anime & TCG Store führen wir nach Verfügbarkeit Yu-Gi-Oh! Booster, Displays und Einzelkarten. Unsere Hauptschwerpunkte sind Pokémon und One Piece – Yu-Gi-Oh! ergänzt unser Sortiment." },
      { q: "Verkauft ihr Yu-Gi-Oh! Einzelkarten?", a: "Ja, je nach Bestand führen wir Yu-Gi-Oh! Einzelkarten – von Meta-Karten bis zu älteren Sammlerstücken. Frag am besten kurz nach dem aktuellen Bestand." },
      { q: "Kauft ihr Yu-Gi-Oh! Karten an?", a: "Wir kaufen gefragte TCG-Karten an. Bring deine Karten während der Öffnungszeiten vorbei – wir bewerten sie gemeinsam mit dir." },
    ],
    related: [
      { to: "/pokemon-karten-koeln", label: "Pokémon Karten Köln" },
      { to: "/one-piece-karten-koeln", label: "One Piece Karten Köln" },
      { to: "/tcg-zubehoer-koeln", label: "TCG Zubehör Köln" },
      { to: "/ankauf", label: "Karten Ankauf" },
    ],
  },

  "anime-figuren-koeln": {
    crumbLabel: "Anime Figuren Köln",
    eyebrow: "Anime Merch & Figuren",
    kanji: "フィギュア",
    heroImage: IMAGES.figures,
    heroAlt: "Anime Figuren im Shibuya Store Köln",
    h1: "Anime Figuren kaufen in Köln",
    intro: [
      "Du suchst Anime Figuren in Köln? Im Shibuya Anime & TCG Store findest du detailreiche Sammelfiguren, Merch und Sammlerartikel deiner Lieblings-Charaktere – handverlesen und regelmäßig neu im Regal. Direkt auf der Zülpicher Straße 357 zum Anschauen und Mitnehmen.",
      "Ob als Highlight fürs eigene Regal oder als Geschenk für Anime-Fans: Bei uns siehst du die Figuren in echt, statt nur auf einem Foto im Online-Shop.",
    ],
    metaTitle: "Anime Figuren kaufen Köln | Sammelfiguren & Merch | Shibuya Store",
    metaDescription:
      "Anime Figuren, Merch und Sammlerartikel im Shibuya Anime & TCG Store Köln. Detailreiche Sammelfiguren und Geschenkideen – vor Ort auf der Zülpicher Str. 357.",
    keywords:
      "Anime Figuren Köln, Anime Figuren kaufen Köln, Anime Merch Köln, Sammelfiguren Köln, Anime Geschenke Köln",
    sections: [
      {
        heading: "Detailreiche Sammelfiguren",
        kanji: "収集",
        body: [
          "Wir führen hochwertige Anime-Figuren – zum Beispiel im Bandai-Grandista-Stil – mit liebevollen Details, die jede Sammlung aufwerten. Unser Sortiment wechselt regelmäßig, schau also gern öfter vorbei.",
        ],
        bullets: [
          "Detailreiche Sammelfiguren bekannter Reihen",
          "Wechselndes, handverlesenes Sortiment",
          "Figuren live ansehen statt nur online",
        ],
      },
      {
        heading: "Merch & Geschenkideen",
        kanji: "贈り物",
        body: [
          "Neben Figuren findest du bei uns stylischen Anime-Merch und Sammlerartikel – ideal als Geschenk für Fans oder als kleines Mitbringsel für dich selbst. Frag uns nach aktuellen Highlights.",
        ],
        bullets: [
          "Anime-Merch deiner Lieblings-Charaktere",
          "Geschenkideen für jeden Anime-Fan",
          "Persönliche Beratung im Store",
        ],
      },
    ],
    faqs: [
      { q: "Habt ihr Anime Figuren in Köln?", a: "Ja, im Shibuya Anime & TCG Store in der Zülpicher Str. 357, 50935 Köln, findest du detailreiche Anime-Figuren, Merch und Sammlerartikel zum Mitnehmen." },
      { q: "Wechselt euer Figuren-Sortiment?", a: "Ja, unser Sortiment ist handverlesen und wird regelmäßig erneuert. Am besten schaust du öfter vorbei oder fragst per WhatsApp nach aktuellen Neuheiten." },
      { q: "Eignen sich die Figuren als Geschenk?", a: "Auf jeden Fall – viele unserer Figuren und Merch-Artikel sind tolle Geschenkideen für Anime-Fans. Wir beraten dich gern im Store." },
    ],
    related: [
      { to: "/pokemon-karten-koeln", label: "Pokémon Karten Köln" },
      { to: "/tcg-zubehoer-koeln", label: "TCG Zubehör Köln" },
      { to: "/ueber-uns", label: "Über uns" },
      { to: "/anfahrt", label: "Anfahrt & Öffnungszeiten" },
    ],
  },

  "tcg-zubehoer-koeln": {
    crumbLabel: "TCG Zubehör Köln",
    eyebrow: "TCG Zubehör",
    kanji: "用品",
    heroImage: IMAGES.tcgCards,
    heroAlt: "TCG Zubehör – Sleeves, Toploader und Binder im Shibuya Store Köln",
    h1: "TCG Zubehör kaufen in Köln",
    intro: [
      "Damit deine Sammelkarten geschützt bleiben, führen wir im Shibuya Anime & TCG Store in Köln das passende Zubehör: Sleeves, Toploader, Binder, Deckboxen und Playmats – für Pokémon, One Piece, Yu-Gi-Oh! und mehr. Vor Ort auf der Zülpicher Straße 357.",
      "Du kannst Material und Qualität direkt vergleichen und dich beraten lassen, welches Zubehör am besten zu deinen Karten und deinem Budget passt.",
    ],
    metaTitle: "TCG Zubehör kaufen Köln | Sleeves, Toploader, Binder & Deckboxen",
    metaDescription:
      "TCG Zubehör in Köln: Sleeves, Toploader, Binder, Deckboxen und Playmats zum Schutz deiner Sammelkarten – im Shibuya Anime & TCG Store, Zülpicher Str. 357.",
    keywords:
      "TCG Zubehör Köln, Sleeves kaufen Köln, Toploader Köln, Binder Köln, Deckbox Köln, Playmat Köln, Kartenschutz Köln",
    sections: [
      {
        heading: "Schutz für deine Sammelkarten",
        kanji: "保護",
        body: [
          "Wertvolle Karten gehören geschützt. Bei uns findest du Sleeves in verschiedenen Stärken, Toploader und Kartenhüllen, mit denen deine Pokémon-, One-Piece- und Yu-Gi-Oh!-Karten sicher bleiben – im Deck wie in der Sammlung.",
        ],
        bullets: [
          "Sleeves in verschiedenen Größen & Stärken",
          "Toploader & feste Kartenhüllen",
          "Schutz für Einzelkarten & Sammlerstücke",
        ],
      },
      {
        heading: "Binder, Deckboxen & Playmats",
        kanji: "整理",
        body: [
          "Zum Sortieren und Transportieren führen wir Binder (Sammelalben), Deckboxen und Playmats. So hast du deine Sammlung ordentlich, dein Deck sicher verstaut und beim Spielen die passende Unterlage.",
        ],
        bullets: [
          "Binder & Sammelalben zum Sortieren",
          "Deckboxen für den sicheren Transport",
          "Playmats für entspanntes Spielen",
        ],
      },
    ],
    faqs: [
      { q: "Habt ihr TCG Zubehör in Köln?", a: "Ja, im Shibuya Anime & TCG Store führen wir Sleeves, Toploader, Binder, Deckboxen und Playmats – vor Ort auf der Zülpicher Str. 357, 50935 Köln." },
      { q: "Welche Sleeves passen für meine Karten?", a: "Wir führen verschiedene Größen und Stärken. Komm einfach mit deinen Karten vorbei – wir helfen dir, die passenden Sleeves zu finden." },
      { q: "Habt ihr Zubehör für Pokémon, One Piece und Yu-Gi-Oh!?", a: "Ja, unser Zubehör eignet sich für alle gängigen TCGs – egal ob Pokémon, One Piece oder Yu-Gi-Oh!." },
    ],
    related: [
      { to: "/pokemon-karten-koeln", label: "Pokémon Karten Köln" },
      { to: "/one-piece-karten-koeln", label: "One Piece Karten Köln" },
      { to: "/yugioh-karten-koeln", label: "Yu-Gi-Oh! Karten Köln" },
      { to: "/anfahrt", label: "Anfahrt & Öffnungszeiten" },
    ],
  },
};

export const landingSlugs = Object.keys(landingData);
